import { DataBean } from "../DataBean";


export class BudgetAusterity extends DataBean {

    public async deleteBudgetAusterity(idbudgetausterity: number): Promise<any> {
        return this.getCustomService("FinanceCore", "boolean_deleteBudgetAusterity_Number", [idbudgetausterity]);
    }

    public async getBudgetAusterityCatalogPorPropiedades(props: any, maxRows: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getBudgetAusterityCatalogPorPropiedades_java.util.Map_Number", [props, maxRows]);
    }

    public async updateBudgetAusterity(bean: any): Promise<any> {
        return this.getCustomService("FinanceCore", "com.orange.bean.BudgetAusterity_updateBudgetAusterity_com.orange.bean.BudgetAusterity", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.orange.bean.BudgetAusterity"
            }
        ]);
    }

}